/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaVnfSecuredConfiguration } from '../shiva-vnf-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ChargePoint } from '../models/charge-point';
import { ChargePointList } from '../models/charge-point-list';
import { configureChargePointVnf } from '../fn/vnf-sites-management/configure-charge-point-vnf';
import { ConfigureChargePointVnf$Params } from '../fn/vnf-sites-management/configure-charge-point-vnf';
import { deleteConfigurationChargePointVnf } from '../fn/vnf-sites-management/delete-configuration-charge-point-vnf';
import { DeleteConfigurationChargePointVnf$Params } from '../fn/vnf-sites-management/delete-configuration-charge-point-vnf';
import { getChargePointsVnf } from '../fn/vnf-sites-management/get-charge-points-vnf';
import { GetChargePointsVnf$Params } from '../fn/vnf-sites-management/get-charge-points-vnf';
import { getChargePointVnf } from '../fn/vnf-sites-management/get-charge-point-vnf';
import { GetChargePointVnf$Params } from '../fn/vnf-sites-management/get-charge-point-vnf';


/**
 * All about the VNF sites configuration / management
 */
@Injectable({ providedIn: 'root' })
export class VnfSitesManagementService extends BaseService {
  constructor(config: ShivaVnfSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `configureChargePointVnf()` */
  static readonly ConfigureChargePointVnfPath = '/custom/stations/{uid}/opcua/{opcuaUid}/configure';

  /**
   * Configure the chargepoints for an opcua connection. The chargepoints can be configured only once.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configureChargePointVnf()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  configureChargePointVnf$Response(params: ConfigureChargePointVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return configureChargePointVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Configure the chargepoints for an opcua connection. The chargepoints can be configured only once.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configureChargePointVnf$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  configureChargePointVnf(params: ConfigureChargePointVnf$Params, context?: HttpContext): Observable<void> {
    return this.configureChargePointVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteConfigurationChargePointVnf()` */
  static readonly DeleteConfigurationChargePointVnfPath = '/custom/stations/{uid}/opcua/{opcuaUid}/configure';

  /**
   * Delete the chargepoint configuration. Allowed only if no transaction has been recorded.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteConfigurationChargePointVnf()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteConfigurationChargePointVnf$Response(params: DeleteConfigurationChargePointVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteConfigurationChargePointVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete the chargepoint configuration. Allowed only if no transaction has been recorded.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteConfigurationChargePointVnf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteConfigurationChargePointVnf(params: DeleteConfigurationChargePointVnf$Params, context?: HttpContext): Observable<void> {
    return this.deleteConfigurationChargePointVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getChargePointsVnf()` */
  static readonly GetChargePointsVnfPath = '/custom/stations/{uid}/chargepoints';

  /**
   * Get the chargepoints for a station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getChargePointsVnf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargePointsVnf$Response(params: GetChargePointsVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePointList>> {
    return getChargePointsVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the chargepoints for a station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getChargePointsVnf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargePointsVnf(params: GetChargePointsVnf$Params, context?: HttpContext): Observable<ChargePointList> {
    return this.getChargePointsVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargePointList>): ChargePointList => r.body)
    );
  }

  /** Path part for operation `getChargePointVnf()` */
  static readonly GetChargePointVnfPath = '/custom/stations/{uid}/chargepoints/{chargePointUid}';

  /**
   * Get a chargepoint for a station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getChargePointVnf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargePointVnf$Response(params: GetChargePointVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePoint>> {
    return getChargePointVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a chargepoint for a station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getChargePointVnf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChargePointVnf(params: GetChargePointVnf$Params, context?: HttpContext): Observable<ChargePoint> {
    return this.getChargePointVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargePoint>): ChargePoint => r.body)
    );
  }

}
